<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <UserNavigationSidebar :toggler.sync="isToggled" />

      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar :profile="getUserProfile" @toggled="toggleSidebarNav"/>

      <div class="card">
        <section id="search-job" class="mt-5">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <JobItem></JobItem>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import JobItem from '@/components/User/CandidateJobItem';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [toggleSidebarNav],
  components: {
    UserNavigationSidebar,
    TopNavbar,
    JobItem,
  },
  data: () => ({ isToggled: false }),
  methods: {
    ...mapActions(['retrieveCandidateUserProfile']),
  },
  computed: { ...mapGetters(['getUserProfile']) },
  mounted() {
    this.retrieveCandidateUserProfile();
  },
};
</script>
